module.exports = __webpack_public_path__ + "img/loan_customer.81ec4959.png";